// Public hook that exposes the singleton event-settings row from the DB.
// Used by the public landing (`/`) and the per-token RSVP page
// (`/confirmacion/:token`) so the artwork renders from the same source
// as the admin edits, while still falling back to EVENT_DATA on the
// first synchronous render (no flash, no layout shift).
//
// The query key is intentionally generic — admin pages that mutate
// settings can invalidate it on success so visitors see fresh values
// on next navigation.
import { useQuery } from '@tanstack/react-query';
import { fetchEventSettings } from '../lib/eventSettings.js';

export const EVENT_SETTINGS_KEY = ['event-settings'];

export function useEventSettings() {
  return useQuery({
    queryKey: EVENT_SETTINGS_KEY,
    queryFn: fetchEventSettings,
    staleTime: 30_000,
    retry: 1,
  });
}
